
import $ from "jquery";
import size from '../../../assets/js/base/_size';
import debug from 'bows/dist/bows.min.js';


let $cpsw = $('.certification-process-section__wrap');
let $body = $('body');
let sliderInitiated = false;
let sliders = [];

const log = debug("sliders:one-across");

function sliderReInit() {
	log('reinit')
	sliderInit();
}

function unslick() {
	log('unslick');
	log(sliders);
	sliders.forEach(slider => {
		slider.slick('unslick');
	});
	sliders = [];
	window.ctia_sliders = [];
}

function sliderInit() {

	$cpsw.each(function () {

		let $this = $(this);
		let role = $this.attr('role');
		let slider = '';
		log($body.width())
		if (role !== 'region' && $body.width() < 1024) {
			slider = $this.slick({
				dots: true,
				speed: 500,
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: false,
				responsive: [
					{
						breakpoint: 1024,
						settings: "unslick"
					},
					{
						breakpoint: 1023,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					},
				]
			});

			sliders.push(slider);
			window.ctia_sliders.push(slider);
		}
		log(sliders);
	});

	if (sliderInitiated === false) {
		size.addMedium(sliderReInit);
		size.addSmall(sliderReInit);
		size.addLarge(unslick);
		sliderInitiated = true;
	}
}



$(function () {

	if ($cpsw.length) {
		sliderInit();
		size.init();
	}
});
